import isEmpty from "lodash/isEmpty";

export default (queryParams, deleteUndefined = false) =>
  Object.entries(queryParams)
    .filter(([param, value]) => {
      if (typeof value === "object") {
        return !isEmpty(value);
      }
      const exceptions = deleteUndefined ? ["", null, undefined] : ["", null];
      return param && !exceptions.includes(value);
    })
    .map(([param, value]) => {
      let trimValue;
      if (typeof value === "string") {
        trimValue = value.trim();
      } else {
        trimValue = value;
      }
      return `${param}=${encodeURIComponent(trimValue)}`;
    })
    .join("&");
